
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import { ModalServices } from '@/services/ModalServices';
import { StorageServices } from './services/StorageServices';
import { CommonServices } from './services/CommonServices';
import { LoginServices } from './services/LoginServices';
import router from './router';
import store from './store';
import { LocalizedClient, LoginClient, ProjectConfigClient } from './services/Services';
import { mode } from './config';
import { LocalizationServices } from './services/LocalizationServices';

@Options({})
export default class App extends Vue {

    loading: boolean = true;
    appMode: string = "";

    mounted(){
        this.appMode = mode;
    
        document.addEventListener("deviceready", this.onDeviceReady, false);
        document.addEventListener("pause", this.onPause, false);
        document.addEventListener("resume", this.onResume, false);

        if(this.$route.name == 'change_password')
            return;

        let proms: any[] = [
            LocalizedClient.getAll(),
            LocalizedClient.getEnabledLanguages(),
            ProjectConfigClient.getProjectConfigVm()
        ];

        Promise.all(proms)
        .then(xs => {
            store.state.consts.localizedValues = xs[0];
            store.state.consts.enabledLanguages = xs[1];
            store.state.consts.projectConfig = xs[2];

            // for(let p in store.state.consts.projectConfig.colors){
            //     document.documentElement.style.setProperty(`--${p}`, store.state.consts.projectConfig.colors[p]);
            // }
            
            
            if(!store.state.selectedLanguage){
                store.state.selectedLanguage = xs[1][0];
            }
            
            let refreshPromise = [];
            let loginData = StorageServices.getLoginData();
            if(loginData && window.location.href.indexOf("/resetPassword/") == -1 && window.location.href.indexOf("/confirmEmail/") == -1){
                refreshPromise.push(LoginClient.refreshLogin());
            } else {
                refreshPromise.push(Promise.resolve());
            }
            Promise.all(refreshPromise)
            .then(x => {

                if(x[0]){
                    LoginServices.loginCallback(x[0])
                    .then(x => {
                        this.loading = false;
                        if(x){
                            if(this.$route.name == 'begin'){
                                this.$router.push("/home");
                            }
                        }
                    })
                } else {
                    // this.$router.push("/");
                    this.loading = false;
                }
            })
            .catch(err => {
                this.loading = false;
            })
        })
        .catch(err => {
            this.loading = false;
        })

        ModalServices.setOpModal(this.$opModal);
    }

    onDeviceReady(){
        if(Keyboard){
            if(device.platform == "iOS"){
                Keyboard.hideFormAccessoryBar(false);
                // Keyboard.setResizeMode('body');
            }
        }

        document.addEventListener("backbutton", () => {
            if(store.state.backButtonFunction){
                store.state.backButtonFunction();
            } else {
                if(this.$opModal.modals().length > 0){
                    this.$opModal.closeLast();
                    return;
                }

                if(this.$route.meta.closeAppModal){
                    ModalServices.confirmModal(
                        '',
                        LocalizationServices.GetLocalizedValue('Vuoi chiudere l\'app?', 'Vuoi chiudere l\'app?'),
                        LocalizationServices.GetLocalizedValue('Si', 'Si'),
                        LocalizationServices.GetLocalizedValue('No', 'No'),
                        () => {
                            (<any>window.navigator).app.exitApp();
                        }
                    )
                } else {
                    this.$router.back();
                }
            }
        }, false);

        universalLinks.subscribe(null, (eventData) => {
            // do some work
            console.log(eventData);
            if(eventData.hash){
                this.$router.replace(eventData.hash);
            }
        });

        window.addEventListener('keyboardWillShow', (event: any) => {
            document.body.classList.add('keyboardopen');
            // if(device.platform == "Android"){
            //     let root = document.documentElement;
            //     root.style.setProperty('--keyboardHeight', (event).keyboardHeight +  "px");
            // }
        });
        window.addEventListener('keyboardWillHide', (event) => {
            document.body.classList.remove('keyboardopen');
            let pageContainer = document.querySelector('.appPageContainer')
            if(pageContainer.scrollHeight <= window.innerHeight){
                pageContainer.scrollTop = 0;
            }

            // if(device.platform == "Android"){
            //     let root = document.documentElement;
            //     root.style.setProperty('--keyboardHeight', "0px");
            // }
        });
    }

    onPause(){

    }

    onResume(){
        
    }

}
